import React, { useContext } from "react";
import ErrorResources from "../../../Components/ErrorResources";
import { ILocalizationContext } from "../../../Localization/Models/ILocalizationContext";
import LocalizationContext from "../../../Localization/LanguageContext";
import { LandingPage } from "../../../Components/LandingPage/LandingPage";

const Blocked = () => {
    const { getValue } = useContext(LocalizationContext) as ILocalizationContext;

    return (
        <LandingPage
            iconProps={{ icon: "octagon-exclamation", size: "xxl" }}
            headingProps={{
                center: true,
                children: getValue('Blocked', 'Title')
            }}
            description={
                <>
                    <div className="error-resources">
                    </div>
                    <ErrorResources />
                </>
            }
        />
    );
}

export default Blocked;